import { unstable_composeClasses as composeClasses, generateUtilityClass } from "@mui/material";
import { editorName } from "../classes.js";
function getEditorUtilityClass(slot) {
  return generateUtilityClass(editorName, slot);
}
function useUtilityClasses(props) {
  const { disabled, error, classes } = props;
  const slots = {
    root: ["root"],
    footer: ["footer", disabled && "footerDisabled"],
    toolbar: ["toolbar", error && "toolbarError"],
    helperText: ["helperText"],
    placeholder: ["placeholder"],
    bottomToolbar: ["bottomToolbar"],
    editorContent: ["editorContent", error && "editorContentError"],
    editorScroller: ["editorScroller", disabled && "editorScrollerDisabled"],
    actionContainer: ["actionContainer"],
    contentEditable: ["contentEditable", disabled && "contentEditableDisabled"],
    quickInsertToolbar: ["quickInsertToolbar"]
  };
  return composeClasses(slots, getEditorUtilityClass, classes);
}
export {
  getEditorUtilityClass,
  useUtilityClasses
};
//# sourceMappingURL=useUtilityClasses.js.map
